import type { SchemaField, SchemaSlotLayout } from '@cli-types/core-engine/schema.js'

export function ensureSlotFields(
  host: { slot?: SchemaSlotLayout },
  slot: 'main' | 'sidebar'
): SchemaField[] {
  if (!host.slot) {
    host.slot = {}
  }

  if (!Array.isArray(host.slot[slot]?.fields)) {
    host.slot[slot] = { fields: [] }
  }

  return host.slot[slot]!.fields
}
